import { create, useModal } from '@ebay/nice-modal-react';
import { useEffect } from 'react';

import useNoPermissionToast from 'hooks/useNoPermissionToast';
import WorkspaceRoleCreate from 'modules/CreateWorkspaceModal/WorkspaceRoleCreate/WorkspaceRoleCreate';
import useWorkspacesContext from 'modules/Workspaces/WorkspacesProvider/useWorkspacesContext';

const WorkspaceRoleCreateModal = create(() => {
  const pushNoPermissionToast = useNoPermissionToast();
  const { remove } = useModal(WorkspaceRoleCreateModal);
  const { workspaceId, workspacePermissions } = useWorkspacesContext({ requireWorkspaceId: true });

  useEffect(() => {
    if (workspacePermissions.adjustRoles) return;

    pushNoPermissionToast();
    remove();
  }, [pushNoPermissionToast, remove, workspacePermissions.adjustRoles]);

  return <WorkspaceRoleCreate onGoBack={remove} workspaceId={workspaceId} />;
});

export default WorkspaceRoleCreateModal;
